import { TFunction } from 'i18next'
import { BrowserType, CardScanError } from '../../model'

interface CardScanTitleInput {
  t: TFunction
  error: CardScanError | undefined
}

interface CardScanSubtitleInput extends CardScanTitleInput {
  browserType: BrowserType
  lastFour?: string
}

type TitleTranslator = (t: TFunction) => string
type SubtitleTranslator = (input: CardScanSubtitleInput) => string

const NO_PERMISSION_SUBTITLE_TRANSLATORS: Record<BrowserType, TitleTranslator> = {
  [BrowserType.Chrome]: (t) => t('cardScan:error.subtitle.no_permission.chrome'),
  [BrowserType.Others]: (t) => t('cardScan:error.subtitle.no_permission.others'),
  [BrowserType.Safari]: (t) => t('cardScan:error.subtitle.no_permission.safari'),
  [BrowserType.Samsung]: (t) => t('cardScan:error.subtitle.no_permission.samsung'),
}

const ERROR_TITLE_TRANSLATORS: Partial<Record<CardScanError, TitleTranslator>> = {
  [CardScanError.Unsupported]: (t) => t('cardScan:error.title.no_permission'),
  [CardScanError.NoPermission]: (t) => t('cardScan:error.title.no_permission'),
  [CardScanError.DidntMatch]: (t) => t('cardScan:error.title.didnt_match'),
  [CardScanError.CannotScan]: (t) => t('cardScan:error.title.cannot_scan'),
  [CardScanError.TooManyTries]: (t) => t('cardScan:error.title.too_many_tries'),
}

const getNoPermissionSubtitle = ({ t, browserType }: CardScanSubtitleInput): string => {
  return NO_PERMISSION_SUBTITLE_TRANSLATORS[browserType](t)
}

const ERROR_SUBTITLE_TRANSLATORS: Partial<Record<CardScanError, SubtitleTranslator>> = {
  [CardScanError.Unsupported]: getNoPermissionSubtitle,
  [CardScanError.NoPermission]: getNoPermissionSubtitle,
  [CardScanError.DidntMatch]: ({ t, lastFour }) => t('cardScan:error.subtitle.didnt_match', { lastFour }),
  [CardScanError.CannotScan]: ({ t, lastFour }) => t('cardScan:error.subtitle.cannot_scan', { lastFour }),
  [CardScanError.TooManyTries]: ({ t }) => t('cardScan:error.subtitle.too_many_tries'),
}

export const getCardScanTitle = ({ t, error }: CardScanTitleInput): string => {
  if (error === undefined) {
    return t('cardScan:title')
  }

  const translateErrorTitle = ERROR_TITLE_TRANSLATORS[error]
  if (translateErrorTitle) {
    return translateErrorTitle(t)
  }

  return t('cardScan:title')
}

export const getCardScanSubtitle = (input: CardScanSubtitleInput): string => {
  const { t, error } = input

  if (error === undefined) {
    return t('cardScan:subtitle')
  }

  const translateErrorSubtitle = ERROR_SUBTITLE_TRANSLATORS[error]
  if (translateErrorSubtitle) {
    return translateErrorSubtitle(input)
  }

  return t('cardScan:subtitle')
}
